import { useEffect, useState } from 'react';
import { useCart } from '../contexts/CartProvider';
import { Col, Container, Row } from 'react-bootstrap';
import ApButton from './Shared/ApButton';
import { Navigate, useParams } from 'react-router-dom';
import ShoppingCart from './ShoppingCart/ShoppingCart';
import { useAuth } from 'contexts/AuthProvider';
import { ApButtonStyle5 } from 'models/ButtonStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import { useUserCountry } from 'contexts/UserCountryProvider';
import { useTranslations } from 'contexts/TranslationProvider';
import { useSiteConfig } from 'contexts/SiteConfigProvider';
import { setGA4EcommerceEvent } from "models/config";

function PreviewCart() {
    const urlParams = useParams();
    const { getCart } = useCart();
    const [redirect, setRedirect] = useState('');
    const { logIn, authenticating, isAuthenticated } = useAuth();
    const { setCurrentLocale } = useTranslations();
    const { setUrlParameters, region, country, locale } = useUserCountry();
    const { getClickHereEmail, getRegistrationLink, getCurrencyCode } = useSiteConfig();
    const currencyCode = getCurrencyCode();

    const redirectToApdOrder = () => {
        if (!authenticating && isAuthenticated()) {
            setRedirect('/order/apdorder');
        }
        else {
            window.location.href = getRegistrationLink();
        }
    };

    useEffect(() => {
        setUrlParameters(urlParams);
    }, []);

    useEffect(() => {
        setCurrentLocale(locale);
        console.log(`[PreviewCart] locale changed to ${locale}...`);
    }, [locale]);

    useEffect(() => {
        if (!authenticating && isAuthenticated()) {
            redirectToApdOrder();
        }
    }, [authenticating]);
    const intl = useIntl();

    useEffect(() => {
        function trackViewCartEvent() {
            const cartData = getCart();
            if (!cartData || cartData.items.length === 0) return;
            let productsValue = 0;
            cartData.items.map(i => productsValue += (i.optimizedPrice ? i.optimizedPrice * i.quantity : 0));
            const ecommerce = {
                currency: currencyCode,
                value: productsValue,
                items: cartData.items.map(i => ({
                    item_id: i.materialNumberTrimmed,
                    item_name: i.materialLongDescription,
                    price: i.optimizedPrice,
                    quantity: i.quantity,
                    currency: currencyCode
                }))
            };
            setGA4EcommerceEvent('view_cart', ecommerce);
        }
        currencyCode && trackViewCartEvent();
    }, [currencyCode]);

    return (
        redirect ? <Navigate to={redirect} /> :
            <>
                <Container>
                    <Row className="text-center mt-3 mb-4">
                        <Col className="text-start my-auto p-0 mb-3">
                            <span className="page-title-level-2 p-0"><FormattedMessage id="ml_114611" defaultMessage="X - Shopping cart" /></span>
                        </Col>
                        <Col className="text-end p-0" md="auto">
                            <div className="btn-style-3 text-center-mobile" >
                                <FormattedMessage id="ml_114610" defaultMessage="X - Register to see your dedicated price today" />
                            </div>
                        </Col>
                    </Row>
                    <ShoppingCart cart={getCart()}></ShoppingCart>
                    <Row className="mt-4">
                        <Col sm={6} md={6} className="p-0 col-order-last">
                            <a className="ap-green link link--default" href={`${import.meta.env.VITE_ONLINE_SHOP_BASE_URL}/${region}/${country}/${locale}/`}>&lt; <FormattedMessage id="ml_114616" defaultMessage="X - CONTINUE SHOPPING" /></a>
                        </Col>
                        <Col sm={6} md={6} className="text-end p-0 mb-3 text-center-mobile">
                            <ApButton innerText={intl.formatMessage({ id: 'ml_114700', defaultMessage: 'X - CHECKOUT' })} btnStyleOption={{ ...ApButtonStyle5, className: 'gtm-tag-register' }} clickHandler={redirectToApdOrder}></ApButton>
                        </Col>
                    </Row>
                    {
                        getClickHereEmail() === '' ? <></> :
                            <Row className="prompt-panel-style-1 click-here-mobile mt-4 ps-5 pt-4 pb-4 d-block">
                                <FormattedMessage id="ml_114701" defaultMessage="X - *If you want more than 10 cylinders then contact us" /><a className="ap-green text-decoration-none p-0 fw-bold" href={`mailto:${getClickHereEmail()}`}>&nbsp;<FormattedMessage id="ml_114702" defaultMessage="X - here" />&nbsp;</a><FormattedMessage id="ml_114703" defaultMessage="X - to set-up an account" />
                            </Row>
                    }
                    <div id="osvc_knowledge" className="mt-4 mx-0"></div>
                    <div id="osvc_inlay"></div>
                </Container>
            </>
    );
}

export default PreviewCart;